// extracted by mini-css-extract-plugin
module.exports = {"bedragen_rechts":"modal-huidige-situatie_bedragen_rechts__2fu_e"};